<template>
  <div>
    <vx-card class="mt-12">
      <ValidationForm
        ref="amcReportSettingFormObserver"
      >
        <AmcReportSettingForm
          v-model:category="category"
          v-model:excellent-user-day="excellentUserDay"
          v-model:excellent-user-purchase="excellentUserPurchase"
          v-model:dormant-user-day="dormantUserDay"
          v-model:arpu-day="arpuDay"
          v-model:is-paid-table="isPaidTable"
        />
      </ValidationForm>
      <div class="text-center self-center">
        <vs-button
          @click="onClickSubmit"
          class="click-submit"
          :disabled="params.category == category &&
          params.excellentUserDay == excellentUserDay &&
          params.excellentUserPurchase == excellentUserPurchase &&
          params.dormantUserDay == dormantUserDay &&
          params.arpuDay == arpuDay &&
          params.isPaidTable == isPaidTable"
        >
          更新
        </vs-button>
      </div>
    </vx-card>
    <vs-popup
      v-model:active="showPopup"
      title=""
    >
      <div
        class="text-center leading-loose"
        v-html="popupMessage"
      />
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Paragraph from '@/components/Paragraph'
import AmcReportSettingForm from '@/components/forms/AmcReportSettingForm'
import { debounce } from '@/utils'

export default {
  components: {
    Paragraph,
    AmcReportSettingForm
  },
  data () {
    return {
      category: null,
      excellentUserDay: null,
      excellentUserPurchase: null,
      dormantUserDay: null,
      arpuDay: null,
      isPaidTable: 0,
      showPopup: false,
      popupMessage: ''
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    ...mapState('amcSetting', ['params'])
  },
  watch: {
    params: {
      handler (val) {
        this.category = val.category
        this.excellentUserDay = val.excellentUserDay
        this.excellentUserPurchase = val.excellentUserPurchase
        this.dormantUserDay = val.dormantUserDay
        this.arpuDay = val.arpuDay
        this.isPaidTable = val.isPaidTable
      }
    }
  },
  async mounted () {
    await this.getParams()
  },
  methods: {
    ...mapActions('amcSetting', ['getParams', 'updateParams']),
    ...mapActions('amcProfile', ['updateAmcProfile']),
    onClickSubmit: debounce(async function () {
      try {
        const { valid } = await this.$refs.amcReportSettingFormObserver.validate()
        if (!valid) return
        const result = await this.updateParams({
          category: this.category,
          excellentUserDay: this.excellentUserDay,
          excellentUserPurchase: this.excellentUserPurchase,
          dormantUserDay: this.dormantUserDay,
          arpuDay: this.arpuDay,
          isPaidTable: this.isPaidTable
        })
        if (result.data.success != false) {
          this.popupMessage = 'AMCレポートの設定が更新されました。'
          this.showPopup = true
          this.updateAmcProfile(result.data.data)
          await this.getParams()
        }
      } catch (e) {
        console.error(e)
      }
    }, 500),
  }
}
</script>

<style scoped>
.click-submit {
  width: 150px;
}
</style>
